const STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Чернетка',
  EXPECTED: 'Очікується',
  NEW: 'Новинка',
  AVAILABLE: 'Доступний',
  FEW_LEFT: 'Закінчується',
  SOLD_OUT: 'Продано',
  ARCHIVED: 'Заархівовано',
  HIDDEN: 'Приховано'
};

const ORDER_STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Чернетка',
  AWAITING_PAYMENT: 'Очікує оплати',
  IN_PROGRESS: 'Нове',
  APPROVED: 'Підтверджено',
  SENT_TO_CLIENT: 'Відправлено',
  WAITING_FOR_CLIENT: 'Очікує клієнта',
  DONE: 'Завершено',
  CANCELED: 'Скасовано',
  EXPIRED: 'Не оплачено вчасно'
};

export function orderStatusLabel(status: string): string {
  return ORDER_STATUS_LABELS[status] ?? status;
}

export function statusLabel(status: string | undefined): string {
  return status ? STATUS_LABELS[status] ?? status : 'Без статусу';
}
